import { check, nonEmpty, nullable, optional, pipe, string, transform } from "valibot";

export function sanitizeHttpUrl(url: string | null | undefined): string | null {
	if (url === null || url === undefined) {
		return null;
	}

	const trimmed = url.trim();
	if (trimmed.length === 0) {
		return null;
	}

	try {
		const parsed = new URL(trimmed);
		if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
			return null;
		}

		return parsed.href;
	} catch {
		return null;
	}
}

export function optionalHttpUrlSchema() {
	return optional(
		nullable(
			pipe(
				string(),
				transform((value) => sanitizeHttpUrl(value))
			)
		)
	);
}

export function requiredHttpUrlSchema(message = "URL must use http or https.") {
	return pipe(
		string(),
		nonEmpty("URL is required."),
		check((value) => sanitizeHttpUrl(value) !== null, message),
		transform((value) => sanitizeHttpUrl(value) as string)
	);
}
